
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { DataSourceZeroStateComponent } from './data-source-zero-state.component';
import { LoadingModule } from '@go-modules/components/loading/loading.module';
import { CoursePaymentWallComponent } from '@go-modules/components/course-payment-wall/course-payment-wall.component';

@NgModule({
	imports: [
		CommonModule,
		NgxZeroStateModule,
		TranslateModule,
		LoadingModule,
		CoursePaymentWallComponent
	],
	declarations: [
		DataSourceZeroStateComponent
	],
	exports: [
		DataSourceZeroStateComponent
	]
})
export class DataSourceZeroStateModule {}
